import {createApp, h} from 'vue'
import {InertiaProgress} from '@inertiajs/progress'
import {createInertiaApp} from '@inertiajs/inertia-vue3'

InertiaProgress.init()
import {Head, Link} from '@inertiajs/inertia-vue3'
import Breadcrumbs from "@/components/general/Breadcrumbs";
import vSelect from 'vue-select'

createInertiaApp({
    resolve: name => import(`./Pages/${name}`),
    title: title => title ? `${title} &mdash; Mazda Accessory Base` : 'Mazda Accessory Base',
    setup({el, App, props, plugin}) {
        createApp({render: () => h(App, props)})
            .use(plugin)
            .component('Link', Link)
            .component('Head', Head)
            .component('Breadcrumbs', Breadcrumbs)
            .component('vSelect', vSelect)
            .mount(el)
    },
})
